import * as yup from 'yup';

import { currencyToNumber } from '@helpers/masks';

export const taxSchema = yup.object().shape({
  aliquot: yup
    .string()
    .required('É necessário informar uma alíquota.')
    .test('min and max value', 'A porcentagem precisa ser entre 0% a 100%.', value => {
      return currencyToNumber(value || '') >= 0 && currencyToNumber(value || '') <= 100;
    }),
});
